module.exports = __webpack_public_path__ + "static/media/dcd-tab-lg-md.1332e195.svg";